import { Component, EventEmitter, Output } from '@angular/core';
import { PrepareActions } from '@app/client/uploader/store/actions';
import * as fromRoot from '@app/reducers';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { regexpVimeo, regexpYoutube } from '@app/shared/helpers/urlHelper';

@Component({
  selector: 'app-modal-customization-receiver-add-background',
  templateUrl: './modal-customization-receiver-add-background.component.html',
  styleUrls: ['./modal-customization-receiver-add-background.component.scss']
})
export class ModalCustomizationReceiverAddBackgroundComponent {

  selectionVideo = false;

  error = false;
  url = null;

  @Output() onAddedImage: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddedVideo: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseModal: EventEmitter<any> = new EventEmitter<any>();

  constructor(public ref: DialogRef, private readonly store$: Store<fromRoot.State & fromUploader.State>,
  ) { }

  displaySelectionVideo(event: Event) {
    this.selectionVideo = true;
    event.preventDefault();
    event.stopPropagation();
  }

  hideSelectionVideo(event: Event) {
    this.selectionVideo = false;
    this.url = null;
    event.preventDefault();
    event.stopPropagation();
  }

  addBackgroundImageToCustomization(image: any) {
    const _image = [image[0]];
    this.store$.dispatch(PrepareActions.addBackgroundImageToAttach({ image: _image }));
    this.closeModal();
  }

  closeModal() {
    this.ref.close();
  }

  addBackgroundVideo(url) {
    let match: any;
    let video: any;
    if (url) {
      if (url.match(regexpYoutube)) {
        match = url.match(regexpYoutube);
        video = { id: Date.now(), sourceUrl: url, sourceId: match[1], type: 'Youtube' };
        this.store$.dispatch(PrepareActions.addBackgroundVideoToAttach({ video }));
        this.url = null;
        this.closeModal();
      } else if (url.match(regexpVimeo)) {
        match = url.match(regexpVimeo);
        video = { id: Date.now(), url, sourceUrl: url, sourceId: match[1], type: 'Vimeo' };
        this.store$.dispatch(PrepareActions.addBackgroundVideoToAttach({ video }));
        this.url = null;
        this.selectionVideo = false;
        this.closeModal();
      } else {
        this.error = true;
      }
    } else {
      this.error = true;
    }
  }
  regexpVimeo(regexpVimeo: any) {
    throw new Error('Method not implemented.');
  }
}
